var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "user-details-sidebar" }, [
    _c(
      "div",
      { staticClass: "user-details-sidebar-item user-select-dropdown" },
      [
        _c("v-autocomplete", {
          staticClass: "user-select-autocomplete",
          attrs: {
            items: _vm.userDropdownItems,
            "menu-props": { contentClass: "user-select-dropdown-menu" },
            placeholder: "Filter options",
            height: "40px",
            attach: "#userDetailsSidebarAttachTarget",
            solo: "",
          },
          scopedSlots: _vm._u([
            {
              key: "append-outer",
              fn: function () {
                return [
                  _c("div", {
                    attrs: { id: "userDetailsSidebarAttachTarget" },
                  }),
                ]
              },
              proxy: true,
            },
          ]),
          model: {
            value: _vm.dropdownSelection,
            callback: function ($$v) {
              _vm.dropdownSelection = $$v
            },
            expression: "dropdownSelection",
          },
        }),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "user-icon-container" },
          [_c("v-icon", { staticClass: "user-icon" }, [_vm._v("fa fa-user")])],
          1
        ),
        _vm._v(" "),
        _c("div", { staticClass: "user-name" }, [
          _vm._v(_vm._s(_vm.userData.name)),
        ]),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "user-email", attrs: { title: _vm.userData.email } },
          [_vm._v(_vm._s(_vm.userData.email))]
        ),
      ],
      1
    ),
    _vm._v(" "),
    _c("div", { staticClass: "user-details-sidebar-item user-profile" }, [
      _c("span", { staticClass: "user-sidebar-header" }, [_vm._v("Profile")]),
      _vm._v(" "),
      _c("hr"),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "user-sidebar-list-item" },
        [
          _c("v-icon", { staticClass: "user-sidebar-icon-mini" }, [
            _vm._v("fa fa-user-circle"),
          ]),
          _c("span", { staticClass: "user-sidebar-list-item-text" }, [
            _vm._v(_vm._s(_vm.userData.title)),
          ]),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "user-sidebar-list-item" },
        [
          _c("v-icon", { staticClass: "user-sidebar-icon-mini" }, [
            _vm._v("far fa-id-card"),
          ]),
          _c("span", { staticClass: "user-sidebar-list-item-text" }, [
            _vm._v(_vm._s(_vm.userData.department)),
          ]),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "user-sidebar-list-item" },
        [
          _c("v-icon", { staticClass: "user-sidebar-icon-mini" }, [
            _vm._v("fa fa-map-marker-alt"),
          ]),
          _c("span", { staticClass: "user-sidebar-list-item-text" }, [
            _vm._v(_vm._s(_vm.userData.location)),
          ]),
        ],
        1
      ),
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "user-details-sidebar-item user-platforms" }, [
      _c("span", { staticClass: "user-sidebar-header" }, [_vm._v("Platforms")]),
      _vm._v(" "),
      _c("hr"),
      _vm._v(" "),
      _c("div", { staticClass: "platform-license-grid" }, [
        _c("div", { staticClass: "license-grid-icon" }, [
          _c("i", {
            class: _vm.getLicenseIconClass(_vm.userData.msTeamsLicense),
          }),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "license-grid-platform" }, [
          _vm._v("MS Teams:"),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "license-grid-status" }, [
          _vm._v(_vm._s(_vm.userData.msTeamsLicense || "Unknown")),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "license-grid-icon" }, [
          _c("i", {
            class: _vm.getLicenseIconClass(_vm.userData.webexLicense),
          }),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "license-grid-platform" }, [_vm._v("Webex:")]),
        _vm._v(" "),
        _c("div", { staticClass: "license-grid-status" }, [
          _vm._v(_vm._s(_vm.userData.webexLicense || "Unknown")),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "license-grid-icon" }, [
          _c("i", {
            class: _vm.getLicenseIconClass(_vm.userData.gmeetLicense),
          }),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "license-grid-platform" }, [_vm._v("GMeet:")]),
        _vm._v(" "),
        _c("div", { staticClass: "license-grid-status" }, [
          _vm._v(_vm._s(_vm.userData.gmeetLicense || "Unknown")),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "license-grid-icon" }, [
          _c("i", { class: _vm.getLicenseIconClass(_vm.userData.zoomLicense) }),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "license-grid-platform" }, [_vm._v("Zoom:")]),
        _vm._v(" "),
        _c("div", { staticClass: "license-grid-status" }, [
          _vm._v(_vm._s(_vm.userData.zoomLicense || "Unknown")),
        ]),
      ]),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }